var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCalendar = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.65005 1.64995C4.65005 1.40058 4.44942 1.19995 4.20005 1.19995C3.95067 1.19995 3.75005 1.40058 3.75005 1.64995V2.39995H3.00005C2.33817 2.39995 1.80005 2.93808 1.80005 3.59995V3.89995V4.79995V9.59995C1.80005 10.2618 2.33817 10.8 3.00005 10.8H9.00005C9.66192 10.8 10.2 10.2618 10.2 9.59995V4.79995V3.89995V3.59995C10.2 2.93808 9.66192 2.39995 9.00005 2.39995H8.25005V1.64995C8.25005 1.40058 8.04942 1.19995 7.80005 1.19995C7.55067 1.19995 7.35005 1.40058 7.35005 1.64995V2.39995H4.65005V1.64995ZM2.70005 4.79995H9.30005V9.59995C9.30005 9.76495 9.16505 9.89995 9.00005 9.89995H3.00005C2.83505 9.89995 2.70005 9.76495 2.70005 9.59995V4.79995Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "02560e67c5ceb17520a31a366dee239d.svg";